/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("application.dataExport", require("./rawicons/dataExport.icon.svg.js"));
